export const POINTS_PER_SWEEP_ENTRY = 250;

export const conversionPointsAsTokens = (points) =>
  Math.floor(points / POINTS_PER_SWEEP_ENTRY);

export const convertUSDToPoints = (usd, exchangeRate) => {
  const usdAsCents = Math.floor(usd * 100);
  return usdAsCents * exchangeRate;
};
